import catalog from "../data/mexicoLocations.json";
import { CM_IN_PERSON, psychSupportsAppointmentModality } from "./consultationModes";

export function getStates() {
  return catalog.states || [];
}

export function getMunicipalitiesForState(stateCode) {
  if (!stateCode) return [];
  return catalog.municipalitiesByState[stateCode] || [];
}

export function getStateByCode(stateCode) {
  return getStates().find((s) => s.code === stateCode);
}

export function getMunicipality(stateCode, municipalityCode) {
  return getMunicipalitiesForState(stateCode).find((m) => m.code === municipalityCode);
}

/** Texto para citas presenciales (México). */
export function formatMexicoLocation(loc) {
  if (!loc || loc.country !== "MX") return "";
  const mun = loc.municipalityName || loc.cityName;
  const st = loc.stateName;
  if (!mun && !st) return "";
  if (st && mun) return `${mun}, ${st}`;
  return mun || st || "";
}

/**
 * Coincidencia entre la consulta presencial del psicólogo y la ciudad/municipio elegido por el paciente.
 * Se comparan códigos INEGI (estado + municipio o alcaldía).
 */
export function psychPracticeMatchesPatientCity(
  psychLocation,
  patientStateCode,
  patientMunicipalityCode
) {
  if (!psychLocation || psychLocation.country !== "MX") return false;
  if (!patientStateCode || !patientMunicipalityCode) return false;
  return (
    psychLocation.stateCode === patientStateCode &&
    psychLocation.municipalityCode === patientMunicipalityCode
  );
}

/**
 * Ubicaciones INEGI (estado + municipio) con al menos un psicólogo que atiende presencial.
 * Mapa: stateCode → Set<municipalityCode>
 */
export function collectInPersonPracticeLocations(psychologists) {
  const byState = new Map();
  for (const p of psychologists || []) {
    if (!psychSupportsAppointmentModality(p.consultationModes, CM_IN_PERSON)) continue;
    const loc = p.location;
    if (!loc || loc.country !== "MX" || !loc.stateCode || !loc.municipalityCode) continue;
    if (!byState.has(loc.stateCode)) {
      byState.set(loc.stateCode, new Set());
    }
    byState.get(loc.stateCode).add(loc.municipalityCode);
  }
  return byState;
}

export function getRegisteredStateCodes(locationsByState) {
  return [...(locationsByState?.keys() || [])].sort();
}

export function getRegisteredMunicipalityCodes(locationsByState, stateCode) {
  if (!stateCode || !locationsByState?.has(stateCode)) return [];
  return [...locationsByState.get(stateCode)].sort();
}
